/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'minus-circle': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M15 12H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"/>'
  }
})
